/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography'
import { BaseModal } from 'components/Modals/BaseModal'
import { CategoryInput, Form } from './Form'
import * as classes from './styles'

export type Props = {
  title: string
  open: boolean
  subjectId: string
  defaultOrder: number
  onSubmit: (category: CategoryInput) => Promise<void>
  onClose: () => void
}

export const CreateCategoryModal = ({ title, open, subjectId, defaultOrder, onSubmit, onClose, ...props }: Props) => (
  <BaseModal open={open} onClose={onClose} {...props}>
    <Typography css={classes.title} variant="title2">
      {title}
    </Typography>
    <Form category={subjectId} defaultOrder={defaultOrder} onSubmit={onSubmit} onCancel={onClose} />
  </BaseModal>
)
